var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"landing-page-widgets",class:[_vm.isFullWidth ? 'full-width-view' : 'sheet-view']},[(!_vm.isPublic)?_c('MembersWidget'):_vm._e(),_vm._v(" "),(_vm.showRecentPages)?_c('RecentPagesWidget'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }